module.exports = __webpack_public_path__ + "img/r-47.c389b590.jpg";